import React from "react";
import styled,{createGlobalStyle} from "styled-components";
import reset from 'styled-reset';
import 'Assets/css/Font/Font.css';

const GlbStyle = createGlobalStyle `
    ${reset}
    * {
        margin: 0;
        padding: 0;
        list-style: none;
        box-sizing: border-box;
        text-decoration: none;
        color:${({theme}) => theme.col.mainFontCol};
        font-family: 'Noto Sans KR', sans-serif;
    }
    s {
        text-decoration: line-through;
    }
    u {
        text-decoration: underline;
    }
    em {
       font-style: italic;
    }
    strong {
        font-weight: 700;
    }
    html, body, div, span, applet, object, iframe, h1, h2, h3, h4, h5, h6, p, blockquote, pre, a, abbr, acronym, address, big, cite, code, del, dfn, em, img, ins, kbd, q, s, samp, small, strike, strong, sub, sup, tt, var, b, u, i, center, dl, dt, dd, menu, ol, ul, li, fieldset, form, label, legend, table, caption, tbody, tfoot, thead, tr, th, td, article, aside, canvas, details, embed, figure, figcaption, footer, header, hgroup, main, menu, nav, output, ruby, section, summary, time, mark, audio, video{
        border:0 solid;
    }
    :lang(ko) {
        word-break: keep-all;
    }
    .rootContainer {
        position: relative;
        min-height: 80vh;
        padding-bottom: var(--ftr-height, 240px);
    }
    a ,button{
        // background: #2A373D
        // border: 1px solid #777777
        color:#fff;
        font-weight: 500;
        font-family: 'Noto Sans KR', sans-serif;
    }
    .ftrWrap {
        position: absolute;
        width: 100%;
        bottom: 0;
    }
    .Container {
        max-width:1400px;
        width:100%;
        margin: 0 auto;
        padding:0 15px;
    }
    .Container h2.SectionTiTl {
        margin-top:50px;
        font-size:20px;
    }
    body {
        color:${({theme}) => theme.col.black000};
        background:${({theme}) => theme.col.bgCol};
    }
    .BgW {
        background: #f8f8f8;
        position: relative;
        min-height: 80vh;
        padding-bottom:130px;
        box-sizing:border-box;
    }
    .MainCol {
        color:${({theme}) => theme.col.mainCol};
    }
    a {
        cursor:pointer;
        text-decoration: none;
    }
    .MsoNormal  {
        margin-bottom:0 !important;
    }
    button {
        background:none;
        outline:none;
        cursor:pointer;
        padding: 8px;
        border: 1px solid #777;
        background: #2A373D;
        transition: all 0.2s;
        min-width:100px;
        color: #fff;
        font-weight: 400;
        border-radius: 5px;
    }
    button:hover {
        border: 1px solid #157dfa;
        background: #157dfa;
    }
    button.colNoneBtn ,button.fixedCmntToggleBtn {
        background:none;
        border:none;
        outline:none;
        cursor:pointer;
        padding: 0;
        border-radius: 0;
        min-width:auto;
    }
    button.colNoneBtn:hover ,button.fixedCmntToggleBtn:hover {
        border: none;
        background: none;
    }
    p,span,label,ol,li,a {
        font-family: 'Noto Sans KR', sans-serif;
        font-weight: 400;
    }
    h1,h2,h3 {
        font-family: 'Noto Sans KR', sans-serif;
        font-weight: 600;
    }
    .MainFontCol {
        color:${({theme}) => theme.col.mainFontCol};
    }
    .SubFontCol{
        color:${({theme}) => theme.col.subFontCol};
    }
    .grecaptcha-badge {
        // visibility:hidden !important;
    }
    .CptchCopy {
        text-align: center;
    }
    .CptchCopy p {
        font-weight: 400;
        font-size:12px;
        color:${({theme}) => theme.col.subFontCol};
    }
    .CptchCopy p a {
        text-decoration: underline;
        font-weight: 400;
        cursor:pointer;
        color:${({theme}) => theme.col.subFontCol};
        margin: 0 5px;
    }
    .container500 {
        max-width:500px;
        width:100%;
        margin:0 auto;
    }
    .container540 {
        max-width:540px;
        width:100%;
        margin:0 auto;
    }
    .container640 {
        max-width:640px;
        width:100%;
        margin:0 auto;
        color:#f9f9f9;
    }
    .contaniner700 {
        max-width:700px;
        width:100%;
        margin:0 auto;
    }
    .container800 {
        max-width:800px;
        width:100%;
        margin:0 auto;
        padding-bottom:50px;
    }
    .container1200{
        max-width:1200px;
        width:100%;
        margin:0 auto;
        padding-bottom:50px;
    }
    .container1300 {
        max-width:1300px;
        width:100%;
        margin:0 auto;
        padding-bottom:200px;
    }
    .container1400 {
        max-width:1400px;
        width:100%;
        margin:0 auto;
    }
    .container1580 {
        max-width:1580px;
        width:100%;
        margin:0 auto;
        padding:0 15px;
    }
    .container1558 {
        max-width:1558px;
        width:100%;
        margin:0 auto;
    }
    input[type=checkbox], input[type=radio] {
        display: none;
    }

    input[type=checkbox] + label::after , input[type=radio] + label::after {
        content: "";
        position: absolute;
        left: 0;
        top:50%;
        transform:translateY(-50%);
        width: 20px;
        height: 20px;
        background: url('/images/common/chkBtn.png');
        background-size: cover;
    }
    input[type=checkbox]:checked + label::after , input[type=radio]:checked + label::after {
        background: url('/images/common/chkBtnOn.png');
        background-size: cover;
    } 
    textarea:focus,input:focus,select:focus,button:focus {
        outline:none;
    }
    select {
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;
        background-color: #fafafa;
        background-size: 17px;
        padding-right: 20px;   
        cursor:pointer;
        border:1px solid #b6b6b6;
        position: relative;
    }
    select:after {
        content: "";
    position: absolute;
    right: 10px;
    top: 50%;
    transform: translateY(-50%);
    width: 17px;
    height: 12px;
    background: url('/public/images/seeMoreBtn.png') no-repeat center center;      
    }
    .dFlex {
        display:flex;
    }
    .flexColumn {
        display: flex;
        flex-direction: column;
    }
    .contentRight {
        justify-content: right;
    }
    .colGreen {
        color: #157dfa;
    }
    .colR{
        color: #ff3939;
    }
    .mt5 {
        margin-top:5px;
    }
    .mt10 {
        margin-top:10px;
    }
    .mt20 {
        margin-top:20px;
    }
    .mt25 {
        margin-top:25px;
    }
    .mt35 {
        margin-top:35px;
    }
    .mt40 {
        margin-top:40px;
    }
    .mt50 {
        margin-top:50px;
    }
    .mt70 {
        margin-top:70px;
    }
    .mt100 {
        margin-top:100px;
    }
    .mt140 {
        margin-top:140px;
    }
    .mt180 {
        margin-top:180px;
    }
    .pt30 {
        padding-top:30px;
    }
    .pt65 {
        padding-top:65px;
    }
    .pt80 {
        padding-top:80px;
    }
    .pt120 {
        padding-top:120px;
    }
    .pt140 {
        padding-top:140px;
    }
    .pt180 {
        padding-top:180px;
    }
    .pb50 {
        padding-bottom:50px;
    }
    .pb70 {
        padding-bottom:70px;
    }
    .pb200 {
        padding-bottom:200px;
    }
    .relative {
        position:relative;
    }
    .mdalBg {
        width:100%;
        height:100vh;
        background:rgba(0,0,0,0.6);
        position:absolute;
        top:0;
        left:0;
    }
    .tCenter  {
        text-align: center; 
    }
    .mdalTrigger span {
        cursor:pointer;
    }
    .leftMenuContainer {
        display: flex;
    }
    .leftMenuWrap {
        max-width:230px;
        width:100%;
        background:#F5F6F7;
        text-align: center; 
        min-height:100vh;
        
    }
    label {
        position: relative;
        cursor: pointer;
        line-height: 20px;
        padding-left: 35px;
    }
    textarea {
        resize: none;
    }
    .gap15 {
        gap:15px;
    }
    .margin0A {
    margin:0 auto;
    }
    .capthCpyr {
        display:none;
    }
    .srchBar {
        display:flex;
        justify-content: flex-end;
        margin-top:30px;
    }
    .srchBar input {
        max-width:250px;
        width:100%;
        border:1px solide #b4b4b4;
        font-size:18px;
        padding:5px;
        font-family: 'Noto Sans KR', sans-serif;
	    font-weight: 500;
    }
    .srchBar button {
        border: 1px solid #00469b;
        margin-left:-1px;
        padding:10px 30px;
        background: #00469b;
        border-radius: 0;
        transition: all 0.2s;
        cursor:pointer;
    }
    .srchBar button:hover {
        background: #157dfa;
        border:1px solid #157dfa;
    }
    .srchBar button p {
        font-size:18px;
        color:#f0f0f0;
        font-weight: 800;
    }
    .w60 {
        width:60%
    }
    .w20 {
        width:20%
    }
    .borderNone {
        border:none;
    }
    button.buttonBgB, div.buttonBgB, a.buttonBgB {
        background: #2A373D;
        color:#f0f0f0;
        border: 1px solid #777777;
        border-radius: 5px;
        transition: all 0.2s;
    }
    button.buttonBgB:hover, div.buttonBgB:hover, a.buttonBgB:hover {
        background: #006EB9;
        border: 1px solid #006EB9;
    }
    @media (hover: hover) and (pointer: fine) {
        button.buttonBgB:hover, div.buttonBgB:hover, a.buttonBgB:hover {
            background: #006EB9;
            border: 1px solid #006EB9;
        }
    }   
    button.buttonBgB p, div.buttonBgB p, a.buttonBgB p  {
        font-size:14px;
        font-weight:700;
    }
    .gap77 {
        gap:77px;
    }
    .gap10 {
        gap: 10px;
    }
    .gap20 {
        gap: 20px;
    }
    .gap3 {
        gap: 3px;
    }
    .gap115 {
        gap:115px;
    }
    .alignCenter {
        align-items: center;
    }
    .jcSpaceBetween {
        justify-content: space-between;
    }
    .jcCenter {
        justify-content: center;
    }
    @media (max-width: 1024px) {
        .rootContainer {
            padding-bottom: var(--ftr-height, 145px);
        }
        .BgW {
            padding-bottom: 80px;
        }
        .BgW.trmsBgW {
            padding-bottom: 80px;
        }
        .mdalTrmsContainer .BgW.trmsBgW {
            padding-bottom:0;    
        }
        .leftMenuWrap {
            max-width: 100%;
            width: 100%;
            background: initial;
            border-right: none;
            padding: 20px 0;
            min-height: auto;
        }
        input[type="checkbox"] + label::after, input[type="radio"] + label::after {
        width: 16px;
        height: 16px;
        }
    }

    .appLoginWrap input[type=checkbox] + label::after , .appLoginWrap input[type=radio] + label::after {
        content: "";
        position: absolute;
        left: 0;
        top:50%;
        transform:translateY(-50%);
        width: 20px;
        height: 20px;
        background: url('/images/Connect/Login/chkBtn.png');
        background-size: cover;
    }
    .appLoginWrap input[type=checkbox]:checked + label::after , .appLoginWrap input[type=radio]:checked + label::after {
        background: url('/images/Connect/Login/chkBtnOn.png');
        background-size: cover;
    } 
`
    
export default GlbStyle;